<label class="form-control__label" data-test-id="basicAddressLabelWrapper">
  <p class="t-data t-bold" data-test-id="basicAddressLabel">
    {{ config.label }}
  </p>
</label>

<div class="basic-address__row" data-test-id="basicAddressRow">
  @for (control of addressLine1; track control; let i = $index) {
    <form-control
      class="basic-address__control"
      [control]="group.controls[config.prop].controls[control.prop]"
      [config]="control"
      direction="grouping"
      [attr.data-test-id]="'basicAddressLine1FormControl_' + i"
    >
    </form-control>
  }
</div>

<div class="basic-address__row basic-address__row--2">
  @for (control of addressLine2; track control; let j = $index) {
    <form-control
      class="basic-address__control"
      [control]="group.controls[config.prop].controls[control.prop]"
      [config]="control"
      direction="grouping"
      [attr.data-test-id]="'basicAddressLine2FormControl_' + j"
    >
    </form-control>
  }
</div>
